import { App } from 'antd'
import React from 'react'
import { useAppVersionCheck } from '../hooks/useAppVersionCheck'

const UpdateBanner: React.FC = () => {
  const { modal } = App.useApp()
  const { updateAvailable, reload } = useAppVersionCheck()

  React.useEffect(() => {
    if (!updateAvailable) return

    modal.info({
      title: 'New version available',
      content:
        'An application update is available. Please refresh to access the latest features.',
      okText: 'Update now',
      onOk: reload,
      centered: true,
      maskClosable: false,
      closable: false,
      styles: {
        mask: {
          backdropFilter: 'blur(6px)',
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
        },
      },
    })
  }, [updateAvailable, modal, reload])

  return <></>
}

export default UpdateBanner
